import React, { useState } from 'react';
import Logo from "../images/logo.svg";
import Select from 'react-select';

function CompanyProfile() {
 const options = [
    { value: 'India', label: 'India' },
    { value: 'United States', label: 'United States' },
    { value: 'Australia', label: 'Australia' }
  ]
  const colourStyles = {
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      console.log({ data, isDisabled, isFocused, isSelected });
      return {
        ...styles,
        backgroundColor: isFocused ? "#F8F8F8" : "",
        color: "#333333",
        borderBottom:1,
        borderStyle:"solid",
        borderColor:"#F2F2F2",
        fontSize:14,
        fontWeight:500,
      };
    }
  };

  const [selectedOption, setSelectedOption] = useState(null);
    // handle onChange event of the dropdown
    const handleChange = e => {
      setSelectedOption(e);
    }

    const [copied, setCopied] = useState(false);

    const copyText = (text) => {
      const tempTextArea = document.createElement('textarea');
      tempTextArea.value = text;
      document.body.appendChild(tempTextArea);
      tempTextArea.select();
      document.execCommand('copy');
      document.body.removeChild(tempTextArea);
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 2000); 
    };


  return (
    <>
    <div id='header'>
        <div className='logo'>
            <div className='logo_icon'>
                <img src={Logo} />
            </div>
            <div className='brand_name'>Company Profiles</div>
        </div>

        <div className='header_table_filter'>
            <div className='searchfield'>
                <button className='btn_search'><i className='icon-search'></i></button>
                <input type='text' className='filter_searchfield' placeholder='Search by ISIN' />
            </div>

            <div className='dropdown_col_filter dropdown_select'>
                <Select options={options}
                styles={colourStyles}
                placeholder="Both Statuses" />
            </div>
            <div className='dropdown_col_filter dropdown_select'>
                <Select options={options}
                styles={colourStyles}
                placeholder="All Countries" />
            </div>
            <div className='dropdown_col_filter dropdown_select'>
                <Select options={options}
                styles={colourStyles}
                placeholder="All Compliance" />
            </div>

            <a href='#' className="btn_clear_filter">Clear Filters</a>
        </div>

        <div className='header_monthly_value'>
            <a href='#/' className='btn_add_new'><i className='icon-plus'></i>Add New</a>
        </div>
    </div>
    <div className="container-fluid content pb-5">
      <div className='company_table_list'>
        <div className='table-responsive'>
          <table className='table'>
              <thead>
                <tr>
                  <th>Ticker And Comapny Name</th>
                  <th>Country</th>
                  <th>Market Cap</th>
                  <th>Exch</th>
                  <th>ISIN</th>
                  <th>Compliance</th>
                  <th style={{textAlign:'center'}}>Status</th>
                  <th>Updated</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='company_lable'>IGNE</span>
                    Igene Biotechnology Inc
                    </div>
                    </td>
                  <td>United States</td>
                  <td>USD 160,000.00</td>
                  <td>Other OTC</td>
                  <td>
                    <div className="table_td_big_content_url" onClick={() => copyText("US4516951005")}>
                      US4516951005
                      {copied && <div className='copied_text'>Copied!</div>}
                    </div>
                  </td>
                  <td><span className='uncover_tag tag_td'>Uncovered</span></td>                  
                  <td>Published</td>
                  <td>Mar 26, 2024</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Create Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-edit'></i></a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='company_lable'>DTI.AX</span>
                    DTI Group Ltd
                    </div>
                    </td>
                  <td>United States</td>
                  <td>USD 310,000.00</td>
                  <td>Other OTC</td>
                  <td>
                    <div className="table_td_big_content_url" onClick={() => copyText("US5746671016")}>
                      US5746671016
                      {copied && <div className='copied_text'>Copied!</div>}
                    </div>
                  </td>
                  <td><span className='uncover_tag tag_td'>Uncovered</span></td>                  
                  <td>Published</td>
                  <td>Mar 26, 2024</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Create Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-edit'></i></a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='company_lable'>BCI.AX</span>
                    BCI Minerals Ltd
                    </div>
                    </td>
                  <td>India</td>
                  <td>USD 469,400,000.00</td>
                  <td>NASDAQ</td>
                  <td>
                    <div className="table_td_big_content_url" onClick={() => copyText("US67577C1053")}>
                      US67577C1053
                      {copied && <div className='copied_text'>Copied!</div>}
                    </div>
                  </td>
                  <td><span className='not_halal_tag tag_td'>Not halal</span></td>                  
                  <td>Published</td>
                  <td>Mar 26, 2024</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Create Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-edit'></i></a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='company_lable'>HZR.AX</span>
                     Hazer Group Ltd
                    </div>
                    </td>
                  <td>Australia</td>
                  <td>USD 310,000.00</td>
                  <td>Other OTC</td>
                  <td>
                    <div className="table_td_big_content_url" onClick={() => copyText("US5746671016")}>
                      US5746671016
                      {copied && <div className='copied_text'>Copied!</div>}
                    </div>                    
                  </td>
                  <td><span className='uncover_tag tag_td'>Uncovered</span></td>                  
                  <td>Published</td>
                  <td>Mar 26, 2024</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Create Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-edit'></i></a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr> 
                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='company_lable'>EWC.AX</span>
                    Energy World Corporation
                    </div>
                    </td>
                  <td>United States</td>
                  <td>USD 1,617,640,000.00</td>
                  <td>NYSE</td>
                  <td>
                    <div className="table_td_big_content_url" onClick={() => copyText("US10806B1008")}>
                      US10806B1008
                      {copied && <div className='copied_text'>Copied!</div>}
                    </div>  
                  </td>
                  <td><span className='not_halal_tag tag_td'>Not halal</span></td>                  
                  <td>Published</td>
                  <td>Mar 26, 2024</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Create Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-edit'></i></a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='company_lable'>SVG.AX</span>
                    Savannah Goldfields Ltd
                    </div>
                    </td>
                  <td>India</td>
                  <td>USD 300,000.00</td>
                  <td>Other OTC</td>
                  <td>
                    <div className="table_td_big_content_url" onClick={() => copyText("US3072511088")}>
                      US3072511088
                      {copied && <div className='copied_text'>Copied!</div>}
                    </div>
                  </td>
                  <td><span className='uncover_tag tag_td'>Uncovered</span></td>                  
                  <td>Published</td>
                  <td>Mar 26, 2024</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Create Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-edit'></i></a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='company_lable'>CDO.AX</span>
                    Cadence Opportunities
                    </div>
                    </td>
                  <td>United States</td>
                  <td>USD 24,340,000.00</td>
                  <td>NASDAQ</td>
                  <td>
                    <div className="table_td_big_content_url" onClick={() => copyText("US77467X1019")}>
                      US77467X1019
                      {copied && <div className='copied_text'>Copied!</div>}
                    </div>
                  </td>
                  <td><span className='halal_tag tag_td'>Halal</span></td>                  
                  <td>Published</td>
                  <td>Mar 26, 2024</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Create Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-edit'></i></a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr> 

                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='company_lable'>SGM.AX</span>
                    Sims Ltd
                    </div>
                    </td>
                  <td>United States</td>
                  <td>USD 561,940,000.00</td>
                  <td>NASDAQ</td>
                  <td>
                    <div className="table_td_big_content_url" onClick={() => copyText("US30292L1070")}>
                      US30292L1070
                      {copied && <div className='copied_text'>Copied!</div>}
                    </div>
                  </td>
                  <td><span className='not_halal_tag tag_td'>Halal</span></td>                  
                  <td>Published</td>
                  <td>Mar 26, 2024</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Create Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-edit'></i></a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr> 
                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='company_lable'>DUB.AX</span>
                    Dubber Corp Ltd
                    </div>
                    </td>
                  <td>Australia</td>
                  <td>USD 803,590,000.00</td>
                  <td>NYSE</td>
                  <td>
                    <div className="table_td_big_content_url" onClick={() => copyText("US21867A1051")}>
                      US21867A1051
                      {copied && <div className='copied_text'>Copied!</div>}
                    </div>
                  </td>
                  <td><span className='not_halal_tag tag_td'>Halal</span></td>                  
                  <td>Published</td>
                  <td>Mar 26, 2024</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Create Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-edit'></i></a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='company_lable'>KRM.AX</span>
                    Kingsrose Mining Ltd
                    </div>
                    </td>
                  <td>United States</td>
                  <td>USD 5,220,000.00</td>
                  <td>NASDAQ</td>
                  <td>
                   <div className="table_td_big_content_url" onClick={() => copyText("US98740Y3027")}>
                       US98740Y3027
                      {copied && <div className='copied_text'>Copied!</div>}
                    </div>
                  </td>
                  <td><span className='doughtful_tag tag_td'>DOUBTFUL</span></td>                  
                  <td>Published</td>
                  <td>Mar 26, 2024</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Create Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-edit'></i></a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr>                
              </tbody> 
          </table>
        </div>

        <nav aria-label="..." id='pagination_row'>
            <ul class="pagination">
                <li class="page-item disabled">
                <a class="page-link"><i className='icon-prev'></i></a>
                </li>
                <li class="page-item"><a class="page-link" href="#">1</a></li>
                <li class="page-item active" aria-current="page">
                <a class="page-link" href="#">2</a>
                </li>
                <li class="page-item"><a class="page-link" href="#">3</a></li>
                <li class="page-item"><a class="page-link" href="#">4</a></li>
                <li class="page-item"><a class="page-link" href="#">5</a></li>
                <li class="page-item">
                <a class="page-link" href="#"><i className='icon-next'></i></a>
                </li>
            </ul>
            </nav>
      </div>
    </div>
    </>
  );
}

export default CompanyProfile;
